import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as styles from "./PrimaryTopNav.module.css";
import clsx from "clsx";
import { Link } from "@utrecht/component-library-react/dist/css-module";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faChevronRight } from "@fortawesome/free-solid-svg-icons";
export const PrimaryTopNav = _ref => {
  let {
    items,
    mobileLogo,
    layoutClassName
  } = _ref;
  const [isOpen, setIsOpen] = React.useState(false);
  const [subNavIsOpen, setSubNavIsOpen] = React.useState({});
  const handleItemClick = handleClick => {
    if (handleClick) {
      handleClick();
      setIsOpen(false);
    }
  };
  const handleSubItemMenu = (idx, value) => {
    setSubNavIsOpen({
      ...subNavIsOpen,
      [idx]: value
    });
  };
  const screenWidth = window.innerWidth;
  React.useEffect(() => {
    if (screenWidth > 992) {
      setSubNavIsOpen({});
    }
  }, [screenWidth]);
  return _jsxs("div", {
    className: clsx(styles.container, layoutClassName && layoutClassName),
    children: [_jsxs("div", {
      className: styles.menuToggleContainer,
      children: [mobileLogo, _jsx("button", {
        className: styles.menuToggle,
        onClick: () => setIsOpen(o => !o),
        children: _jsx(FontAwesomeIcon, {
          icon: faBars
        })
      })]
    }), _jsx("nav", {
      className: clsx(styles.primary, isOpen && styles.isOpen),
      children: _jsx("ul", {
        className: styles.ul,
        children: items.map((_ref2, idx) => {
          let {
            label,
            icon,
            current,
            handleClick,
            subItems
          } = _ref2;
          return _jsxs("li", {
            onClick: () => !subItems ? handleItemClick(handleClick) : screenWidth > 992 ? handleItemClick(handleClick) : handleSubItemMenu(idx, !subNavIsOpen[idx] ?? true),
            className: clsx(styles.li, current && styles.current),
            children: [_jsxs(Link, {
              className: clsx(styles.link, styles.label, subItems && styles.mobileLink, current && styles.currentLink),
              children: [icon, label, " ", subItems && screenWidth < 992 && _jsx(FontAwesomeIcon, {
                className: clsx(styles.toggleIcon, subNavIsOpen[idx] && styles.isOpen),
                icon: faChevronRight
              })]
            }), subItems && _jsx("ul", {
              className: clsx(styles.dropdown, subNavIsOpen[idx] && styles.isOpen),
              children: subItems.map((_ref3, idx) => {
                let {
                  label,
                  icon,
                  current,
                  handleClick
                } = _ref3;
                return _jsx("li", {
                  className: clsx(styles.li, current && styles.current),
                  onClick: () => handleItemClick(handleClick),
                  children: _jsxs(Link, {
                    className: clsx(styles.link, styles.label, current && styles.currentLink),
                    children: [icon, label]
                  })
                }, idx);
              })
            })]
          }, idx);
        })
      })
    })]
  });
};